<template>
	<div>
		<div>
			<div class="flex xs-12 xs-between mt6">
				<div class="fs4 lh125 fw7 c1 mb2">{{ $t("transaction") }}</div>

				<j-button
					v-can="['writeTransactions']"
					type="tertiary"
					@click="handleUpdate"
				>
					<crm-icon name="edit" color="c2" size="small" />
					{{ $t("update") }}
				</j-button>
			</div>
			<j-card class="bg5">
				<j-list :list="computedTransactions">
					<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
						<div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">
							{{ item.label }}
						</div>
						<div class="flex xs-6 xs-left xs-middle lh125">
							<template
								v-if="
									item.label === 'Transaction For' &&
										item.value.includes('policy') &&
										data.object.id
								"
							>
								<router-link
									:to="
										`/${$route.params.tenantId}/policies/detail/policy/${
											data.object.id
										}`
									"
								>
									{{ item.value }}
								</router-link>
							</template>
							<template
								v-else-if="
									item.label === 'Transaction For' &&
										item.value.includes('claim') &&
										data.object.id
								"
							>
								<router-link
									:to="
										`/${$route.params.tenantId}/claims/detail/${data.object.id}`
									"
								>
									{{ item.value }}
								</router-link>
							</template>
							<template
								v-else-if="
									item.label === 'Transaction For' &&
										item.value.includes('proposal') &&
										data.object.id
								"
							>
								<router-link
									:to="
										`/${$route.params.tenantId}/case-management/detail/${
											data.object.case.id
										}`
									"
								>
									{{ item.value }}
								</router-link>
							</template>
							<template
								v-else-if="
									item.label === 'Transaction For' &&
										item.value.includes('endorsement') &&
										data.object.id
								"
							>
								<router-link
									:to="
										`/${$route.params.tenantId}/policies/detail/endorsements/${
											data.object.id
										}`
									"
								>
									{{ item.value }}
								</router-link>
							</template>
							<template v-else>
								{{ item.value }}
							</template>
						</div>
					</div>
				</j-list>
				<div class="bg5 ta2 fs3 p2" v-if="!computedTransactions">
					{{ $t("errors.no_data") }}
				</div>
			</j-card>
		</div>

		<!-- Update Transaction -->
		<core-modal name="updateTransaction" :headline="$t('update_transaction')">
			<transaction-update
				:transactionId="transactionToUpdateId"
				:initialPayload="transactionToUpdatePayload"
				@transaction:updated="
					$modal.hide('updateTransaction'), $emit('onUpdate')
				"
				@cancel="$modal.hide('updateTransaction')"
			/>
		</core-modal>
	</div>
</template>

<script>
import TransactionUpdate from "./TransactionUpdate"
import CoreModal from "@/modules/core/components/CoreModal"
import JCard from "@/components/JCard/"
import JList from "@/components/JList/"
import JButton from "@/components/JButton/"
import CrmIcon from "@/components/CrmIcon/"
import dayjs from "dayjs"

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},

	components: {
		JCard,
		JList,
		JButton,
		CrmIcon,
		CoreModal,
		TransactionUpdate
	},

	data() {
		return {
			transactionToUpdateId: null,
			transactionToUpdatePayload: null
		}
	},

	computed: {
		computedTransactions() {
			const allkKeys = Object.keys(this.data)
			const excludeKeys = [
				"id",
				"status",
				"createdAt",
				"createdBy",
				"lastModifiedBy",
				"lastModifiedAt",
				"facts"
			]
			const translateKeyMapping = {
				method: "payment_method",
				dateTime: "date",
				formattedTransaction: "amount",
				currencyCode: "currency_code",
				transactionNumber: "number",
				postDateTime: "post_date",
				dueDateTime: "due_date",
				object: "transaction_for"
			}

			const listTimes = ["dateTime", "postDateTime", "dueDateTime"]

			const keys = allkKeys.filter(k => !excludeKeys.includes(k))

			return keys.map(key => {
				if (key === "object" && this.data[key])
					return {
						label: this.$t(translateKeyMapping[key]),
						value: this.data[key].issuerNumber
							? this.data[key].__typename + " - " + this.data[key].issuerNumber
							: this.data[key].__typename
					}
				else if (listTimes.includes(key))
					return {
						label: this.$t(translateKeyMapping[key]),
						value:
							this.data[key] &&
							dayjs(this.data[key]).format("DD/MM/YYYY HH:mm:ss")
					}
				else
					return {
						label: this.$t(translateKeyMapping[key]),
						value: this.data[key]
					}
			})
		}
	},

	methods: {
		handleUpdate() {
			this.transactionToUpdateId = this.data.id
			this.transactionToUpdatePayload = {
				amount: this.data.amount,
				transactionNumber: this.data.transactionNumber,
				currencyCode: this.data.currencyCode,
				status: this.data.status,
				dateTime: this.data.dateTime
					? dayjs(this.data.dateTime).format("DD/MM/YYYY HH:mm:ss")
					: "",
				postDateTime: this.data.postDateTime
					? dayjs(this.data.postDateTime).format("DD/MM/YYYY HH:mm:ss")
					: "",
				dueDateTime: this.data.dueDateTime
					? dayjs(this.data.dueDateTime).format("DD/MM/YYYY HH:mm:ss")
					: "",
				method: this.data.method,
				object: this.data.object ? JSON.stringify(this.data.object) : null
			}

			// Open popup
			this.$modal.show("updateTransaction")
		}
	}
}
</script>
